<template>
    <div class="parent-container">
        <div class="change-password-container">
            <form @submit.prevent="handleSubmit">
                <div class="form-group">
                    <label class="form-label" for="name">旧密码</label>
                    <input type="text" id="oldPassword" v-model="form.oldPassword" class="form-input" placeholder="请输入旧密码" required>
                </div>
                <div class="form-group" style="color: #94a3b8;">旧密码校验结果: {{ isOldPasswordRight }}</div>
                <div class="form-group">
                    <label class="form-label" for="name">新密码</label>
                    <input type="text" id="newPassword" v-model="form.newPassword" class="form-input" placeholder="请输入新密码" required>
                </div>
                <div class="form-group">
                    <label class="form-label" for="name">确认密码</label>
                    <input type="text" id="confirmPassword" v-model="form.confirmPassword" class="form-input" placeholder="请输入确认密码" required>
                </div>
                <div class="form-group-button">
                    <button type="submit" class="form-button">提    交</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import encrypt from '@/utils/encrypt.js';
import { changeUserPassword, confirmOldPassword } from '@/api/setting/user.js'

export default {
    data() {
        return {
            form: {
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            },
            user: {},
            isOldPasswordRight: false,
        };
    },
    mounted() {
        const str = window.localStorage.getItem("user");
        if (str) {
            this.user = JSON.parse(str);
        }
    },
    methods: {
        handleSubmit() {
            // 在此处编写提交修改密码的逻辑

            if (this.isOldPasswordRight === false) {
                this.$message.error('旧密码输入错误');
                return
            }
            // 以下为示例逻辑，您需要根据实际情况修改
            if (this.form.newPassword !== this.form.confirmPassword) {
                this.$message.error('新密码与确认密码不一致');
                return;
            }

            const newPasswordRSA = encrypt.encrypt(this.form.newPassword)


            const data = {
                id: this.user.id,
                password: newPasswordRSA,
                name: this.user.name,
                sex: this.user.sex,
                code: this.user.code
            }
            changeUserPassword(
                data
            ).then(
                () => {
                    this.$message.success('密码修改成功');
                }
            ).catch(
                () => {
                    this.$message.error('密码修改失败，请稍后再试');
                }
            )
            // 调用修改密码接口并处理结果
            // modifyPassword(this.form).then(response => {
            //   this.$message.success('密码修改成功');
            // }).catch(error => {
            //   this.$message.error('密码修改失败，请稍后再试');
            // });
        },
        confirmOldPassword() {

            const params = {
                name: this.user.code, // code才是用户名
                password: encrypt.encrypt(this.form.oldPassword),
            };

            confirmOldPassword(params).then(
                () => {
                    this.isOldPasswordRight = true
                }
            ).catch((error) => {
                this.isOldPasswordRight = false
                console.log(error)
            })
        }
    },

};
</script>

<style scoped>
.change-password-container {
    min-width: 400px;
    background: rgba(20, 35, 70, 0.5);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 16px;
    padding: 2rem;
    margin-bottom: 1.5rem;
    color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.form-group {
    margin-bottom: 1.5rem;
}

.form-label {
    display: block;
    margin-bottom: 0.5rem;
    color: #94a3b8;
    font-size: 0.9rem;
}

.form-input {
    width: 100%;
    padding: 0.75rem 1rem;
    background: rgba(10, 20, 40, 0.6);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 10px;
    color: #fff;
    font-size: 1rem;
    transition: all 0.3s ease;
}

.form-input:focus {
    outline: none;
    border-color: #00ff96;
    background: rgba(10, 20, 40, 0.8);
    box-shadow: 0 0 20px rgba(0, 255, 150, 0.2);
}

.form-input::placeholder {
    color: #64748b;
}
.form-button{
    padding: 0.5rem 1rem;
    background: rgba(0, 255, 150, 0.1);
    border: 1px solid rgba(0, 255, 150, 0.3);
    border-radius: 6px;
    color: #00ff96;
    font-size: 0.85rem;
    cursor: pointer;
    transition: all 0.3s ease;
}
.form-button:hover {
    background: rgba(0, 255, 150, 0.1);
    border-color: #00ff96;
    color: #00ff96;
}
.form-group-button{
    display: flex;
    justify-content: center;
}
</style>